export default __webpack_public_path__ + "static/media/CoBRA_workflow.b682f78c.svg";